import type { ReactElement } from "react";

import { H } from "../hero-tokens";
import { KundenstimmeClip } from "./kundenstimme-clip";
import type { Kundenstimme } from "./kundenstimmen-data";

/**
 * One testimonial row: 16:9 clip embed + quote. Desktop: even index quote left /
 * video right, odd index flipped; mobile stacks video above text
 * (see .mkhero-stimme-* in hero.css).
 */
export function KundenstimmeItem({
  item,
  index,
}: {
  readonly item: Kundenstimme;
  readonly index: number;
}): ReactElement {
  // Even index: quote left / video right. Odd: video left / quote right.
  const reverse: boolean = index % 2 === 0;
  // i18n-exempt: CSS-Klassennamen aus hero.css, kein Anzeigetext.
  const rowClass = `mkhero-stimme-row${reverse ? " mkhero-stimme-row--reverse" : ""}`;
  const attribution: string = [item.company, item.role]
    .filter(
      (part): part is string => typeof part === "string" && part.length > 0,
    )
    .join(" · ");

  return (
    <article className={rowClass}>
      <div className="mkhero-stimme-video">
        <KundenstimmeClip item={item} />
      </div>

      <div className="mkhero-stimme-copy">
        <span
          aria-hidden="true"
          style={{
            display: "block",
            fontFamily: H.display,
            fontSize: 72,
            lineHeight: 0.7,
            color: H.accent,
            marginBottom: 8,
            userSelect: "none",
          }}
        >
          “
        </span>
        <blockquote
          style={{
            margin: 0,
            fontFamily: H.display,
            fontWeight: 400,
            fontSize: "clamp(1.2rem, 1.8vw, 1.55rem)",
            lineHeight: 1.35,
            letterSpacing: "-0.015em",
            color: H.ink,
          }}
        >
          {item.quote}
        </blockquote>
        <footer style={{ marginTop: 22 }}>
          <div
            style={{
              fontSize: 15.5,
              fontWeight: 600,
              color: H.ink,
              letterSpacing: "-0.01em",
            }}
          >
            {item.name}
          </div>
          {attribution.length > 0 ? (
            <div
              style={{
                marginTop: 3,
                fontSize: 13.5,
                color: H.inkMute,
              }}
            >
              {attribution}
            </div>
          ) : null}
        </footer>
      </div>
    </article>
  );
}
